import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box
} from '@mui/material';
import { CakeOutlined, StarOutlined, MailOutlined, PersonAddOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

export type EventType = 'birthday' | 'tier_update' | 'newsletter_opt_in' | 'registration' | '';

interface EventTypeSelectionProps {
  value: EventType;
  onChange: (eventType: EventType) => void;
  disabled?: boolean;
}

const EventTypeSelection: React.FC<EventTypeSelectionProps> = ({ value, onChange, disabled = false }) => {
  const { t } = useTranslation();
  
  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          {t('campaignExperimental.create.eventTypeTitle')}
        </Typography>
        <Divider sx={{ mb: 3 }} />
        
        <FormControl fullWidth disabled={disabled}>
          <InputLabel>{t('campaignExperimental.create.eventTypeSelect')}</InputLabel>
          <Select
            value={value}
            label={t('campaignExperimental.create.eventTypeSelect')}
            onChange={(e) => onChange(e.target.value as EventType)}
            disabled={disabled}
            sx={{
              '& .MuiSelect-select': {
                display: 'flex',
                alignItems: 'center',
                gap: 1
              }
            }}
          >
            <MenuItem value="" sx={{ fontStyle: 'italic', color: 'text.secondary' }}>
              {t('campaignExperimental.create.eventTypeChoose')}
            </MenuItem>
            <MenuItem value="birthday">
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <CakeOutlined color="primary" />
                <Box>
                  <Typography variant="body1">{t('campaignExperimental.create.birthdayCampaign')}</Typography>
                  <Typography variant="caption" color="text.secondary">
                    {t('campaignExperimental.create.birthdayCampaignDesc')}
                  </Typography>
                </Box>
              </Box>
            </MenuItem>
            <MenuItem value="tier_update">
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <StarOutlined color="secondary" />
                <Box>
                  <Typography variant="body1">{t('campaignExperimental.create.tierUpdateCampaign')}</Typography>
                  <Typography variant="caption" color="text.secondary">
                    {t('campaignExperimental.create.tierUpdateCampaignDesc')}
                  </Typography>
                </Box>
              </Box>
            </MenuItem>
            <MenuItem value="newsletter_opt_in">
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <MailOutlined color="info" />
                <Box>
                  <Typography variant="body1">{t('campaignExperimental.create.newsletterOptInCampaign')}</Typography>
                  <Typography variant="caption" color="text.secondary">
                    {t('campaignExperimental.create.newsletterOptInCampaignDesc')}
                  </Typography>
                </Box>
              </Box>
            </MenuItem>
            <MenuItem value="registration">
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <PersonAddOutlined color="success" />
                <Box>
                  <Typography variant="body1">{t('campaignExperimental.create.registrationCampaign')}</Typography>
                  <Typography variant="caption" color="text.secondary">
                    {t('campaignExperimental.create.registrationCampaignDesc')}
                  </Typography>
                </Box>
              </Box>
            </MenuItem>
          </Select>
        </FormControl>
      </CardContent>
    </Card>
  );
};

export default EventTypeSelection;